export const ANSWER_QUESTION = 'ANSWER_QUESTION';
